import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import type { TemporaryStorageView } from '@meddihub/mzcr-ui';
import { store } from '../../../store/store';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';
import AclContextProvider from '../../Acl/Components/AclContextProvider';
import MzcrTemporaryStoragePage from './MzcrTemporaryStoragePage';

type TemporaryStorageLinks = Record<TemporaryStorageView, string>;

const VIEWS: TemporaryStorageView[] = ['new', 'received', 'sent'];

const parseView = (value: string | null): TemporaryStorageView =>
	VIEWS.find(view => view === value) ?? 'received';

const parseLinks = (value: string | null): TemporaryStorageLinks => {
	try {
		return JSON.parse(value ?? '{}');
	} catch (e) {
		console.error(e);
		return { new: '', received: '', sent: '' };
	}
};

loadDOMComponent({
	selector: 'react-mzcr-temporary-storage',
	callback: ({
		container,
		context,
	}: {
		container: HTMLElement;
		context: React.ComponentProps<typeof AppContextProvider>;
	}) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<MzcrTemporaryStoragePage
							view={parseView(container.getAttribute('view'))}
							links={parseLinks(container.getAttribute('links'))}
							workplaceName={
								container.getAttribute('workplace-name') || undefined
							}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
